import styled from "styled-components";

export const Button = styled.button`
  border: none;
  border-radius: 3px;
  background-color: #2196f3;
  padding: 8px 16px;
  min-width: 100px;
  font-size: 14px;
  font-weight: bold;
  color: white;
  cursor: pointer;
`;
export const ButtonResponsive = styled.button`
  border: none;
  border-radius: 2px;
  background-color: #2196f3;
  padding: 2px 4px;
  min-width: 50px;
  font-size: 6px;
  font-weight: bold;
  color: white;
  cursor: pointer;
`;
